<template>
    <base-lined-card
        class="link-card"
        :image="image"
        :title="title"
        :href="externalLink"
        :to="to"
    >
        <markdown-content
            v-if="text"
            class="text"
            :content="text"
        />

        <b-button
            variant="primary"
        >
            {{ buttonText }}
        </b-button>
    </base-lined-card>
</template>

<script>
    import BaseLinedCard from '../BaseLinedCard/BaseLinedCard';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent.vue';

    export default {
        name: 'link-card',

        components: { MarkdownContent, BaseLinedCard },

        props: {
            image: {
                type: Object,
                default: () => ({}),
            },

            title: {
                type: String,
                default: '',
            },

            text: {
                type: String,
                default: '',
            },

            externalLink: {
                type: String,
                default: '',
            },

            to: {
                type: String,
                default: '',
            },

            buttonText: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .text {
        margin-bottom: 16px;
    }

    .base-lined-card {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;

        ::v-deep .title {
            margin-bottom: 5px;
        }

        ::v-deep .textual-content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .btn {
        margin-top: auto;
        cursor: inherit;
    }
</style>
